<template>

    <card>
        <template v-slot:header>
            Aktuelle Auslastung 
        </template>

        <chart-half-donut
                class="mb-2"
                :data="data"
                headline="FooBar"
                :colors="colors"></chart-half-donut>
    </card>
    
</template>

<script>
import Reservation from "./Reservation";
import Modal from "./Modal";
import ButtonPrimary from "./UI/ButtonPrimary";
import Card from "./UI/Card";
import TailwindTable from "./UI/TailwindTable";
import ButtonSecondary from "./UI/ButtonSecondary";
import some from "lodash/some";
import sortBy from "lodash/sortBy";
import filter from "lodash/filter";
import ChartHalfDonut from "./Chart/ChartHalfDonut";

export default {
    name: "Schedules",
    components: {
        ButtonSecondary,
        TailwindTable,
        Card,
        ButtonPrimary,
        Modal,
        Reservation,
        ChartHalfDonut
    },
    props: {type: {}, text: {}, item: {}, reservations: {}},

    data: () => ({
        showAll: false,
        today: new Date().toISOString().slice(0, 10),
        colors: ['#FF968A','#FFC8BF', '#CCE2CB']
    }),

    computed: {
        typeId() {
            return parseInt(this.type);
        },
        activeDesksCount() {
            return this.activeDesks.map((d) => {
                return d.schedules.filter((s) => {
                    return s.day === this.today && s.status === 'confirmed';
                }).length;
            }).reduce((a, b) => a + b, 0);
        },
        activeGuestDesksCount() {
            return this.activeGuestDesks.reduce((a, b) => a + b.schedules.length, 0);
        },
        activeDesks() {
            return sortBy(
                this.items
                    .filter(s => s.status === 'confirmed')
                    .filter(s => s.schedules[0].user_id !== null)
                    .filter(s => filter(s.schedules, {day: this.today})), // a user may have more than one desk!
                'from');
        },
        activeGuestDesks() {
            return sortBy(
                this.items
                    .filter(s => s.status === 'confirmed')
                    .filter(s => s.schedules[0].user_id === null)
                    .filter(s => s.schedules[0].day === this.today),
                'from');
        },
        future() {
            return sortBy(
                this.items
                    .filter(s => s.status === 'confirmed')
                    .filter(s => s.user_id === null)
                    .filter(s => !some(s.schedules, {day: this.today})),
                'from'
            );
        },
        items() {
            return this.reservations
                .filter(s => s.schedules[0].desk.desk_type_id === this.typeId);
        },
        data() {
            return [{label: 'von Mitarbeitern', value: this.activeDesksCount}, {label: 'für Gäste', value: this.activeGuestDesks}, {label: 'freie Schreibtische', value: this.item}];
        }

    },
}
</script>

<style scoped>

</style>
